import { render, staticRenderFns } from "./tools-page.vue?vue&type=template&id=3fc06d32&scoped=true"
import script from "./tools-page.vue?vue&type=script&lang=js"
export * from "./tools-page.vue?vue&type=script&lang=js"
import style0 from "./tools-page.vue?vue&type=style&index=0&id=3fc06d32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc06d32",
  null
  
)

export default component.exports